<template>
  <div v-loading="pageLoading">
    <div>
      <el-form :model="form"
               style="margin: auto; width: 1000px">
        <el-form-item label="賬號"
                      :label-width="formLabelWidth">
          <el-input v-model="form.account"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="密碼"
                      :label-width="formLabelWidth">
          <el-input v-model="form.pwd"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="分公司"
                      :label-width="formLabelWidth">
          <el-select v-model="form.regionId"
                     filterable
                     reserve-keyword
                     placeholder="請選擇分公司"
                     style="width: 80%;"
                     @change="selectRegion"
                     :loading="regionLoading">
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業"
                      :label-width="formLabelWidth">
          <el-select v-model="form.branchId"
                     filterable
                     reserve-keyword
                     :placeholder="form.regionId ? '請選擇部門/物業' : '請先選擇分公司'"
                     style="width: 80%;"
                     @change="selectBranch"
                     :disabled="!form.regionId">
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別"
                      :label-width="formLabelWidth">
          <el-select v-model="form.departmentId"
                     filterable
                     reserve-keyword
                     :placeholder="form.branchId ? '請選擇用戶組別' : '請先選擇部門/物業'"
                     style="width: 80%;"
                     @change="selectDep"
                     :disabled="!form.branchId">
            <el-option v-for="item in department"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位"
                      :label-width="formLabelWidth">
          <el-select v-model="form.positionId"
                     filterable
                     reserve-keyword
                     :placeholder="form.branchId ? '請選擇職位' : '請先選擇部門/物業'"
                     style="width: 80%;"
                     @change="loadEmployee"
                     :disabled="!form.branchId">
            <el-option v-for="item in position"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名"
                      :label-width="formLabelWidth">
          <el-select v-model="form.name"
                     placeholder="请选择姓名"
                     style="width: 80%">
            <el-option v-for="item in employee"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色"
                      :label-width="formLabelWidth">
          <el-select v-model="form.manRoleId"
                     placeholder="请选择角色"
                     style="width: 80%">
            <el-option v-for="item in role"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="課程審核"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="form.type"
                          style="width:550px">
            <el-radio :disabled="isPersonnel"
                      label="0">非審核人員</el-radio>
            <el-radio :disabled="isPersonnel"
                      label="3">總公司內部審核</el-radio>
            <!-- <el-radio label="1">公司內部審核</el-radio>
            <el-radio :disabled="isPersonnel"
                      label="2">部門內部審核</el-radio> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary"
                   @click="addUser">確 定</el-button>
      </div>
      <el-button class="btn"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      form: {
        account: "",
        pwd: "",
        name: "",
        regionId: "",
        branchId: "",
        departmentId: "",
        positionId: "",
        type: "0",
        manRoleId: "",
      },
      formLabelWidth: "130px",
      region: [],
      filiale: [],
      department: [],
      position: [],
      employee: [],
      role: [],
      isPersonnel: false,
      regionLoading: false
    };
  },
  mounted () {
    $("#pageHead").text("新增後台用戶");
    // 獲取級聯
    this.regionLoading = true
    this.$store.dispatch('commonData/getEchoDistrictBranchDepartmentList').then(() => {
      this.region = this.$store.state.commonData.echoDistrictBranchDepartmentList
      this.regionLoading = false
    })

    // 獲取角色
    this.$store.dispatch('commonData/getRoleList').then(() => {
      this.role = this.$store.state.commonData.roleList
    })
    // 獲取員工
    that.loadEmployee();
  },
  methods: {
    addUser () {
      var form = that.form;
      var msg = {
        password: form.pwd,
        account: form.account,
        comUserId: form.name,
        manRoleId: form.manRoleId,
        type: form.type,
      };
      if (form.pwd.length < 0) {
        that.$message({
          type: "warning",
          message: "請填寫密碼!",
        });
        return;
      }
      for (let item in msg) {
        if (msg[item] == "") {
          that.$message({
            type: "warning",
            message: "請將信息填寫完整!",
          });
          return;
        }
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/addManUser",
        params: msg,
        method: "post",
      }).then(res => {
        if (res) {
          that.$message({
            type: "success",
            message: "新增成功!",
          });
          setTimeout(function () {
            that.$router.go(-1);
          }, 1000);
        } else {
          this.pageLoading = false
        }
      }).catch(() => {
        this.pageLoading = false
      })
    },
    selectRegion (val) {
      // 已選擇地區
      var reg = that.region;
      for (let i = 0; i < reg.length; i++) {
        if (reg[i].id == val) {
          (that.form.branchId = ""),
            (that.form.departmentId = ""),
            (that.form.positionId = ""),
            (that.department = []),
            (that.position = []),
            (that.filiale = reg[i].branchList);
          break;
        }
      }
      this.loadEmployee();
    },
    selectBranch (val) {
      // 已選分公司
      var fil = that.filiale;
      this.isPersonnel = false;
      for (let i = 0; i < fil.length; i++) {
        if (fil[i].id == val) {
          that.form.departmentId = '';
          that.form.positionId = '';
          // that.position = [];
          that.department = fil[i].departmentList;
          that.position = fil[i].positionList;

          break;
        }
      }
      this.loadEmployee();
    },
    selectDep (val) {
      // 已選部門
      var dep = that.department;
      for (let i = 0; i < dep.length; i++) {
        if (dep[i].id == val) {
          if (dep[i].departmentName == "人事部") {
            this.isPersonnel = true;
          } else {
            this.isPersonnel = false;
          }
          // that.form.positionId = '',
          break;
        }
      }
      this.loadEmployee();
    },
    loadEmployee () {
      this.form.name = "";
      this.pageLoading = true
      var msg = this.utils.filtration(that.form);
      this.axios({
        url: "/common/initialize/getAllComUserList",
        params: msg,
      }).then((res) => {
        that.employee = res.result;
        this.pageLoading = false
      });
    },
  },
  created () {
    that = this;
  },
};
</script>

<style scoped>
/* .btn {
	margin-left: 20px;
} */

.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.el-form-item {
  width: 500px;
  display: inline-block;
}

.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
